import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Link, BrowserRouter as Router, Routes } from "react-router-dom";
import App from "./App";
import Popup from "reactjs-popup";

export default function Navbar({ onChange }) {
  localStorage.setItem("balance", 0);
  var [users, setUsers] = useState([]);
  var [data, setData] = useState();
  var [profile, setProfile] = useState(0);

  function myFunction() {
    const payment = document.getElementById("payment").value;
    const fname = document.getElementById("name").value;
    var arr = [fname, payment];
    users.push(arr);
    setUsers(users);
    console.log("Users:", users);
    createSigninData();
  }

  function createSigninData() {
    console.log("createSigninData sddsd");
    setData(
      users.map(us => {
        return (
          <div>
            <br></br>
            <br></br>
            <input
              type="button"
              value={us[0]}
              onClick={() => updateProfile(us[0], us[1])}
            />
            <input
              type="button"
              value={us[1]}
              onClick={() => updateProfile(us[0], us[1])}
            />
          </div>
        );
      })
    );
    console.log("data:", data);
  }

  function updateProfile(profile, balance) {
    console.log("updateProfile called=========================", profile);

    sessionStorage.setItem("name", profile);
    // localStorage.setItem("balance", balance);
    // sessionStorage.setItem("profile", profile);
    sessionStorage.setItem("balance", balance);
    setProfile(profile);
    console.log(
      "updateProfile called profileeeeeeeeee=========================",
      profile
    );

    onChange(balance);
  }

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container-fluid">
        <div>
          {profile && <h3 style={{ color: "White" }}>Welcome {profile}</h3>}
          {!profile && (
            <Popup
              trigger={<button> Register </button>}
              position="right center"
            >
              <div>
                {/* <form> */}
                <br></br>
                <br></br>
                <label>
                  <br></br>
                  <br></br>
                  Name:
                  <input type="text" id="name" name="name" />
                </label>
                <br></br>
                <label>
                  Payment:
                  <input type="number" id="payment" name="payment" />
                </label>
                <br />
                <input type="button" value="Submit" onClick={myFunction} />
                {/* </form> */}
              </div>
            </Popup>
          )}

          {!profile && (
            <Popup trigger={<button> Sign In </button>} position="right center">
              <div>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
                {/* <p>wdewffe</p> */}
                {data}
                <br></br>
                <br></br>
              </div>
            </Popup>
          )}

          {profile && (
            <button onClick={() => updateProfile("", 0)}> Sign Out </button>
          )}
        </div>
        <h2 className="name">Casino Application by Dheeraj Chauhan</h2>
      </div>
    </nav>
  );
}
